import React from "react";
import styled from "styled-components";

export default ({ mobile = false }) => {
  return (
    <ListOf mobile={mobile}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.001 2.00195C6.47895 2.00195 2.00195 6.47895 2.00195 12.001C2.00195 16.991 5.65795 21.1269 10.439 21.8799V14.892H7.89895V12.001H10.439V9.79795C10.439 7.28995 11.932 5.90695 14.215 5.90695C15.309 5.90695 16.455 6.10195 16.455 6.10195V8.56095H15.191C13.951 8.56095 13.563 9.33295 13.563 10.124V11.999H16.334L15.891 14.89H13.563V21.878C18.344 21.129 22 16.992 22 12.001C22 6.47895 17.523 2.00195 12.001 2.00195Z"
          fill={mobile?"#3E3E3E":"#FFFFFF"}
        />
      </svg>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0001 7.19298C9.33995 7.19298 7.19308 9.33986 7.19308 12C7.19308 14.6602 9.33995 16.807 12.0001 16.807C14.6603 16.807 16.8071 14.6602 16.8071 12C16.8071 9.33986 14.6603 7.19298 12.0001 7.19298ZM12.0001 15.1242C10.2798 15.1242 8.87589 13.7203 8.87589 12C8.87589 10.2797 10.2798 8.87579 12.0001 8.87579C13.7204 8.87579 15.1243 10.2797 15.1243 12C15.1243 13.7203 13.7204 15.1242 12.0001 15.1242ZM17.004 5.87579C16.3829 5.87579 15.8814 6.37736 15.8814 6.99845C15.8814 7.61954 16.3829 8.12111 17.004 8.12111C17.6251 8.12111 18.1267 7.62189 18.1267 6.99845C18.1269 6.85097 18.0979 6.7049 18.0416 6.56861C17.9852 6.43232 17.9026 6.30849 17.7983 6.2042C17.694 6.09991 17.5701 6.01723 17.4339 5.96087C17.2976 5.90452 17.1515 5.87561 17.004 5.87579ZM21.3704 12C21.3704 10.7063 21.3821 9.42423 21.3095 8.13283C21.2368 6.63283 20.8946 5.30158 19.7978 4.2047C18.6985 3.10548 17.3696 2.76564 15.8696 2.69298C14.5759 2.62033 13.2939 2.63204 12.0025 2.63204C10.7087 2.63204 9.42667 2.62033 8.13527 2.69298C6.63527 2.76564 5.30402 3.10783 4.20714 4.2047C3.10792 5.30392 2.76808 6.63283 2.69542 8.13283C2.62277 9.42658 2.63449 10.7086 2.63449 12C2.63449 13.2914 2.62277 14.5758 2.69542 15.8672C2.76808 17.3672 3.11027 18.6984 4.20714 19.7953C5.30636 20.8945 6.63527 21.2344 8.13527 21.307C9.42902 21.3797 10.711 21.368 12.0025 21.368C13.2962 21.368 14.5782 21.3797 15.8696 21.307C17.3696 21.2344 18.7009 20.8922 19.7978 19.7953C20.897 18.6961 21.2368 17.3672 21.3095 15.8672C21.3845 14.5758 21.3704 13.2938 21.3704 12ZM19.3079 17.5266C19.1368 17.9531 18.9306 18.2719 18.6001 18.6C18.2696 18.9305 17.9532 19.1367 17.5267 19.3078C16.2939 19.7977 13.3665 19.6875 12.0001 19.6875C10.6337 19.6875 7.70402 19.7977 6.4712 19.3102C6.04464 19.1391 5.72589 18.9328 5.39777 18.6024C5.0673 18.2719 4.86105 17.9555 4.68995 17.5289C4.20246 16.2938 4.31261 13.3664 4.31261 12C4.31261 10.6336 4.20246 7.70392 4.68995 6.47111C4.86105 6.04454 5.0673 5.72579 5.39777 5.39767C5.72824 5.06954 6.04464 4.86095 6.4712 4.68986C7.70402 4.20236 10.6337 4.31251 12.0001 4.31251C13.3665 4.31251 16.2962 4.20236 17.529 4.68986C17.9556 4.86095 18.2743 5.0672 18.6025 5.39767C18.9329 5.72814 19.1392 6.04454 19.3103 6.47111C19.7978 7.70392 19.6876 10.6336 19.6876 12C19.6876 13.3664 19.7978 16.2938 19.3079 17.5266Z"
          fill={mobile?"#3E3E3E":"#FFFFFF"}
        />
      </svg>
      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.471111 0.4375L6.31104 8.4036L0.4375 14.875H1.75674L6.89924 9.2104L11.0586 14.875H15.5625L9.39486 6.46728L14.8651 0.4375H13.5458L8.80667 5.66048L4.975 0.4375H0.471111ZM2.41215 1.43114H4.47924L13.6047 13.8814H11.5376L2.42056 1.43114H2.41215Z" 
          fill={mobile?"#3E3E3E":"#FFFFFF"}
          />
      </svg>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.32766 3H19.6684C20.4023 3 21 3.58104 21 4.29786V19.7012C21 20.4179 20.4023 21 19.6684 21H4.32766C3.59521 21 3 20.4179 3 19.7012V4.29786C3 3.58104 3.59521 3 4.32766 3ZM6.91478 5.4C7.75 5.4 8.42809 6.07958 8.42809 6.9168C8.42809 7.75429 7.75 8.43387 6.91478 8.43387C6.07623 8.43387 5.4 7.75429 5.4 6.9168C5.4 6.07958 6.07623 5.4 6.91478 5.4ZM5.60737 18H8.22096V9.58375H5.60737V18ZM9.85894 9.58374H12.3618V10.7343H12.3975C12.7457 10.0727 13.5976 9.37488 14.8679 9.37488C17.5116 9.37488 18.0001 11.1175 18.0001 13.3842V18H15.3894V13.9072C15.3894 12.9312 15.3726 11.6756 14.0327 11.6756C12.6741 11.6756 12.4668 12.7394 12.4668 13.8373V18H9.85894V9.58374Z"
          fill={mobile?"#3E3E3E":"#FFFFFF"}
        />
      </svg>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_20553_103191)">
          <path
            d="M10.9999 2C6.0296 2 2.00049 6.02951 2.00049 10.9994C2.00049 15.9693 6.03 19.9988 10.9999 19.9988C15.9698 19.9988 19.9993 15.9693 19.9993 10.9994C19.9993 6.02951 15.9706 2 10.9999 2ZM15.7613 9.9381C15.6701 9.94722 15.5789 9.95158 15.4877 9.95198C14.9944 9.95215 14.5089 9.82944 14.0749 9.59494C13.6409 9.36044 13.2721 9.02152 13.002 8.60881V13.183C13.002 14.0796 12.6458 14.9395 12.0119 15.5736C11.3779 16.2076 10.518 16.5639 9.62144 16.564C8.72476 16.564 7.86481 16.2078 7.23076 15.5737C6.59672 14.9397 6.24052 14.0797 6.24052 13.183C6.24052 12.2866 6.5965 11.4269 7.2302 10.7929C7.86391 10.1589 8.72345 9.80254 9.61985 9.80212C9.69042 9.80212 9.7594 9.80847 9.82878 9.81283V11.4779C9.75962 11.4667 9.68985 11.4597 9.61985 11.4569C9.39324 11.4568 9.16884 11.5014 8.95947 11.5881C8.75009 11.6748 8.55984 11.8019 8.39959 11.9621C8.23933 12.1223 8.11221 12.3125 8.02548 12.5219C7.93875 12.7312 7.89411 12.9556 7.89411 13.1822C7.89411 13.4089 7.93875 13.6332 8.02548 13.8426C8.11221 14.052 8.23933 14.2422 8.39959 14.4024C8.55984 14.5626 8.75009 14.6897 8.95947 14.7764C9.16884 14.8631 9.39324 14.9076 9.61985 14.9076C10.5713 14.9076 11.4146 14.1567 11.4146 13.2029L11.4312 5.43444H13.025C13.0978 6.12685 13.4116 6.77165 13.9116 7.2561C14.4117 7.74056 15.0661 8.03385 15.7605 8.0847L15.7613 9.9381Z"
            fill={mobile?"#3E3E3E":"#FFFFFF"}
          />
        </g>
        <defs>
          <clipPath id="clip0_20553_103191">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </svg>
    </ListOf>
  );
};

const ListOf = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  margin-top: 22px;
  justify-content: ${(props) => (props.mobile ? "center" : "flex-start")};
`;
